import dayjs from "dayjs";
import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { StatusBadge, ViewButton } from "@components";

import { RoomConferenceType } from "@type/inventory/room-conference";
import { NavigateFunction } from "react-router-dom";

export const RoomConferenceListTableColumn = (
  t: TFunction<"translation", undefined>,
  navigate: NavigateFunction,
) => {
  return [
    {
      id: 1,
      key: "roomId",
      name: t("INVENTORY_ROOM_CONFERENCE.TABLE.COLUMN.ROOM"),
      render: (room: string) => (
        <Text className="text-subtitle1 text-nowrap text-info">{room}</Text>
      ),
    },
    {
      id: 2,
      key: "officeId",
      name: t("INVENTORY_ROOM_CONFERENCE.TABLE.COLUMN.OFFICE"),
      render: (office: string) => (
        <Text className="text-subtitle1 text-nowrap">{office}</Text>
      ),
    },
    {
      id: 3,
      key: "buildingId",
      name: t("INVENTORY_ROOM_CONFERENCE.TABLE.COLUMN.BUILDING"),
      render: (building: string) => (
        <Text className="text-subtitle1 text-nowrap">{building}</Text>
      ),
    },
    {
      id: 4,
      key: "meetingPurpose",
      name: t("INVENTORY_ROOM_CONFERENCE.TABLE.COLUMN.PURPOSE"),
      render: (purpose: string) => (
        <Text className="text-subtitle1 text-nowrap">{purpose}</Text>
      ),
    },
    {
      id: 6,
      key: "bookingStartTime",
      name: t("INVENTORY_ROOM_CONFERENCE.TABLE.COLUMN.TIME"),
      render: (bookingStartTime: string, rows: RoomConferenceType) => {
        return (
          <>
            <Text size="sm" component="p" color="subtitle1">
              {dayjs(bookingStartTime).format("YYYY-MM-DD")}&nbsp;
              {dayjs(bookingStartTime).format("hh:mm:ss")} -&nbsp;
              <span className="text-warning">
                {dayjs(rows?.bookingEndTime).format("YYYY-MM-DD")}&nbsp;
                {dayjs(rows.bookingEndTime).format("hh:mm:ss")}
              </span>
            </Text>
          </>
        );
      },
    },
    {
      id: 7,
      key: "status",
      name: t("INVENTORY_ROOM_CONFERENCE.TABLE.COLUMN.STATUS"),
      render: (data: string) => (
        <StatusBadge status={data ? data : "pending"} />
      ),
    },
    {
      id: 8,
      key: "id",
      name: "",
      render: (id: string | number) => {
        return (
          <div
            onClick={() => {
              navigate(`${id}`);
            }}
            className="cursor-pointer"
          >
            <ViewButton />
          </div>
        );
      },
    },
  ];
};
